import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap"; 
import { Link } from "react-router-dom";

const logoImage = require("../assets/images/velvetLogo.png");

const navItems = [
  { title: "Bosh sahifa", path: "#home" },
  { title: "Biz xaqimizda", path: "#about" },
  // { title: "Features", path: "#features" },
  { title: "Mahsulotlarimiz", path: "#generalFeatures" },
  { title: "Ijtimoiy tarmoqlar", path: "#social-media" },
  { title: "Mijozlarimiz", path: "#testimonials" },
  // { title: "Blogs", path: "#blogs" },
  { title: "Kontaktlar", path: "#contact" },
];

const Header = () => {
  const [scrolling, setScrolling] = useState(false);
  const [openNav, setOpenNav] = useState(false);

  const handleNavigation = () => {
    setOpenNav(!openNav);
  };

  useEffect(() => {
    const handleScroll = (e) => {
      if (
        document.body.scrollTop >= 50 ||
        document.documentElement.scrollTop >= 50
      ) {
        setScrolling(true);
      } else {
        setScrolling(false);
      }
    };

    window.addEventListener("scroll", (e) => {
      e.preventDefault();
      handleScroll();
    });

    window.addEventListener("scroll", handleScroll);
  }, []);
  return (
    <>
      {/* - Site Header - */}
      <header
        className={`site-header d-lg-block d-none ${
          scrolling ? "sticky-header" : ""
        }`}
      >
        <Container>
          <Row>
            <Col md={12}>
              <div className="header-content">
                {/* - Header Left - */}
                <div className="header-left">
                  <div className="site-logo">
                    <a href="#home">
                      <img src={logoImage} alt="Site Logo" />
                    </a>
                  </div>
                </div>
                {/* - Header Left - */}

                {/* - Header Right - */}
                <div className="header-right">
                  <div className="site-navigation">
                    <ul>
                      {(navItems || []).map((item) => (
                        <li key={item.path}>
                          <a href={item.path}>{item.title}</a>
                        </li>
                      ))}
                    </ul>
                  </div>
                  <div className="ms-4">
                    <Link
                      to="tel:+998996327070"
                      className="anchor-button secondary button-sm"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        style={{ marginRight: "8px" }}
                      >
                        <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
                      </svg>
                      +998 99 632 70 70
                    </Link>
                  </div>
                </div>
                {/* - Header Right - */}
              </div>
            </Col>
          </Row>
        </Container>
      </header>
      {/* - Site Header - */}

      {/* - Site Mobile Header - */}
      <header
        className={`site-mobile-header d-block d-lg-none ${
          scrolling ? "sticky-header" : ""
        }`}
      >
        <Container>
          <Row>
            <Col md={12}>
              <div className="header-content">
                {/* - Header Left - */}
                <div className="header-left">
                  <div className="site-logo">
                    <a href="#home">
                      <img
                        src={logoImage}
                        alt="Site Logo"
                        onClick={handleNavigation}
                      />
                    </a>
                  </div>
                </div>
                {/* - Header Left - */}

                {/* - Header Right - */}
                <div className="header-right">
                  <div className="me-4">
                    <Link
                      to="tel:+998996327070"
                      className="anchor-button secondary button-sm"
                    >
                      +998 99 632 70 70
                    </Link>
                  </div>
                  <div className="mobile-nav-toggle" onClick={handleNavigation}>
                    <i className="las la-bars"></i>
                  </div>
                </div>
                {/* - Header Right - */}
              </div>
            </Col>
          </Row>
        </Container>
      </header>
      {/* - Site Mobile Header - */}

      {/* - Mobile Navigation - */}
      <div className={`mobile-navigation-wrap p-4 ${openNav ? "show" : ""}`}>
        <div className="nav-header">
          <i
            className="las la-times-circle hide-mobile-nav"
            onClick={handleNavigation}
          ></i>
        </div>

        {/* - Navigation Items - */}
        <div className="mobile-nav">
          <ul>
            {(navItems || []).map((item) => (
              <li key={item.path}>
                <a href={item.path} onClick={handleNavigation}>
                  {item.title}
                </a>
              </li>
            ))}
          </ul>
        </div>
        {/* - Navigation Items - */}
      </div>
      {/* - Mobile Navigation - */}
    </>
  );
};

export default Header;
